// extracted by mini-css-extract-plugin
module.exports = {"button":"EmptyBlock_button__RC6S1"};